// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3lHM7","text":"SelectPayment_text__2opkg","title":"SelectPayment_title__2fVR6","btn":"SelectPayment_btn__3aJb4"};